const VALID_FLOW_PARAMS = ['payment', 'payment_method'];
const VALID_STEP_PARAMS = ['overview', 'action'];
const VALID_CLIENT_PARAMS = ['m', 'p', 'pl'];
export function parseFlowParam(value) {
    const lower = value?.toLowerCase();
    return VALID_FLOW_PARAMS.includes(lower) ? lower : undefined;
}
export function parseStepParam(value) {
    const lower = value?.toLowerCase();
    return VALID_STEP_PARAMS.includes(lower) ? lower : undefined;
}
export function parseClientParam(value) {
    const lower = value?.toLowerCase();
    return VALID_CLIENT_PARAMS.includes(lower) ? lower : undefined;
}
/**
 * Maps a ClientParam to the corresponding Rubiks ThemeType.
 */
export function clientParamToThemeType(client) {
    switch (client) {
        case 'm':
            return 'magicline';
        case 'p':
            return 'perfectgym';
        case 'pl':
            return 'perfectleisure';
    }
}
/**
 * Parses comma-separated debt claim IDs string into number array.
 * Example: "1344063677,1344063620" → [1344063677, 1344063620]
 */
export function parseDebtClaimIds(value) {
    if (!value) {
        return undefined;
    }
    const ids = value
        .split(',')
        .map(Number)
        .filter((n) => !isNaN(n) && n > 0);
    return ids.length > 0 ? ids : undefined;
}
/**
 * Decodes the base64 path segment into identity params (t, token).
 * The blob is a base64-encoded query string: "t=gymlab&token=xxx"
 */
export function decodeIdentityParams(base64) {
    try {
        const decoded = atob(base64);
        const params = new URLSearchParams(decoded);
        return {
            t: params.get('t') ?? undefined,
            token: params.get('token') ?? undefined,
            c: parseClientParam(params.get('c')) ?? 'm'
        };
    }
    catch {
        return {};
    }
}
export function isValidFflSearchParams(params) {
    return Boolean(params.t && params.token && params.c);
}
/**
 * Checks whether the current URL contains redirect params from a payment provider.
 * After a redirect-based payment (TWINT, PayPal, iDEAL), the PSP appends
 * `redirectResult` and/or `paymentToken` to the return URL.
 */
export function hasRedirectParams() {
    const params = new URLSearchParams(window.location.search);
    return params.has('redirectResult') || params.has('paymentToken');
}
/**
 * Writes activeFlow and activeStep to the URL query params via history.replaceState.
 * Preserves all existing query params (flow, debtClaims, paymentToken, redirectResult, etc.).
 */
export function writeStateToUrl(activeFlow, activeStep) {
    const url = new URL(window.location.href);
    url.searchParams.set('activeFlow', activeFlow);
    url.searchParams.set('activeStep', activeStep);
    window.history.replaceState(window.history.state, '', url.toString());
}
export function writePaymentSessionToUrl(userSessionToken, fpRegion) {
    const url = new URL(window.location.href);
    url.searchParams.set('ust', userSessionToken);
    if (fpRegion) {
        url.searchParams.set('fpRegion', fpRegion);
    }
    else {
        url.searchParams.delete('fpRegion');
    }
    window.history.replaceState(window.history.state, '', url.toString());
}
export function parseDataParam(raw) {
    const idx = raw.indexOf('&');
    if (idx < 0) {
        return { base64: raw, extras: new URLSearchParams() };
    }
    return {
        base64: raw.substring(0, idx),
        extras: new URLSearchParams(raw.substring(idx + 1))
    };
}
const TRANSIENT_PARAMS = [
    'activeFlow',
    'activeStep',
    'ust',
    'fpRegion',
    'redirectResult',
    'paymentToken'
];
function withoutTransientParams() {
    const url = new URL(window.location.href);
    TRANSIENT_PARAMS.forEach((param) => url.searchParams.delete(param));
    return url;
}
export function clearStateFromUrl() {
    const url = withoutTransientParams();
    window.history.replaceState(window.history.state, '', url.toString());
}
export function buildRestartUrl() {
    return withoutTransientParams().toString();
}
